import { combineReducers } from "redux"
import homeReducer from "./Home/reducer"

export default combineReducers({
  home: homeReducer,
})
